import { Box, styled } from '@mui/material';

export const TopInformations = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
